import { fork, takeLatest } from "typed-redux-saga";
import { rootActions } from "../reducers/root.slice";
import generateGraphSaga from "./generate-graph.saga";
import initialiseSaga from "./initialise.saga";
import loadDatasetFromFile from "./load-dataset-from-file.saga";
import convertToContinuous from "./convert-to-continuous.saga";
import applyReorder from "./apply-reorder.saga";
import revertToCategorical from "./revert-to-categorical.saga";
import loadPrevOrNextColumnSaga from "./load-prev-or-next-column.saga";
import { loadPrevOrNextMethod } from "./load-prev-or-next-method.saga";
import rotateHeatMap from "./rotate-heat-map.saga";
import {
  dCOrWorkerXSaga,
  dCorWorkerYSaga,
  dCorWorkerZSaga,
} from "./worker-sagas/dcor-worker.saga";
import pcaWorkerSaga from "./worker-sagas/pca-worker.saga";
import tauWorkerSaga from "./worker-sagas/tau-worker.saga";
import findClickedPoint from "./find-clicked-point.saga";
import logisticRegressionWorkerSaga from "./worker-sagas/logistic-regression-worker.saga";
import linearRegressionWorkerSaga from "./worker-sagas/linear-regression-worker.saga";
import silhouetteScoreWorker from "./worker-sagas/silhouette-score-worker.saga";
import generateScoresSaga from "./generate-scores.saga";
import { workerActions } from "../reducers/worker.slice";

export function* rootWatcher() {
  yield* takeLatest(rootActions.initialise, initialiseSaga);
  yield* takeLatest(rootActions.loadPrevOrNextMethod, loadPrevOrNextMethod);
  yield* takeLatest(rootActions.generateGraph, generateGraphSaga);
  yield* takeLatest(rootActions.findClickedPoint, findClickedPoint);
  yield* takeLatest(rootActions.loadDatasetFromFile, loadDatasetFromFile);
  yield* takeLatest(rootActions.convertToContinuous, convertToContinuous);
  yield* takeLatest(rootActions.applyReorder, applyReorder);
  yield* takeLatest(rootActions.revertToCategorical, revertToCategorical);
  yield* takeLatest(rootActions.rotateHeatMap, rotateHeatMap);
  yield* takeLatest(
    rootActions.loadPrevOrNextColumnSaga,
    loadPrevOrNextColumnSaga
  );
  yield* takeLatest(workerActions.generateScores, generateScoresSaga);
}

export default function* rootSaga() {
  yield* fork(dCOrWorkerXSaga);
  yield* fork(dCorWorkerYSaga);
  yield* fork(dCorWorkerZSaga);
  yield* fork(pcaWorkerSaga);
  yield* fork(tauWorkerSaga);
  yield* fork(logisticRegressionWorkerSaga);
  yield* fork(linearRegressionWorkerSaga);
  yield* fork(silhouetteScoreWorker);

  yield* fork(rootWatcher);
}
